
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Product,
  ProductCategory,
  ProductProperty,
} from "@/script/apps/shop/entity/ShopEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { ProductService } from "@/script/apps/shop/service/ProductService";
import { ProductCategoryService } from "@/script/apps/shop/service/ProductCategoryService";
import { ElMessage } from "element-plus";
import { AppConfig } from "@/script/core/base/AppConfig";
import { TagService } from "@/script/apps/cms/service/TagService";
import { Tag } from "@/script/apps/cms/entity/CmsEntity";
import { Dict } from "@/script/apps/system/entity/SystemEntity";
import TinymceEditor from "@/components/TinymceEditor.vue";

@Options({
  components: {
    TinymceEditor,
  },
})
export default class ProductDetail extends BaseDetail {
  private refreshKey = 1;

  private tagValues: number[] = [];

  private tagOptions: any[] = [];

  protected productCategorys: Tag[] = [];

  private productCategoryList: ProductCategory[] = [];

  private productService = new ProductService();

  public defaultProperty = "describe";
  private preProperty = "";

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_shop_product",
      "/shop/product",
      "/shop/product",
      this.productService
    );
    data.statesName = "product-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    salePrice: [{ required: true, message: "请输入销售价格", trigger: "blur" }],
    categoryId: [
      { required: true, message: "请选择商品分类", trigger: "change" },
    ],
  };

  activated() {
    // 强制刷新组件
    this.refreshKey += 1;
    this.tagValues = [];
  }

  public newEntity() {
    const entity: Product = {};

    entity.productPropertys = [];
    entity.productPropertys.push({
      type: "text",
      name: "describe",
      label: "产品描述",
      content: "",
    });
    entity.productPropertys.push({
      type: "text",
      name: "parameter",
      label: "产品参数",
      content: "",
    });
    entity.productPropertys.push({
      type: "text",
      name: "video",
      label: "产品视频",
      content: "",
    });
    this.setEditorContent("describe");
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    const productCategoryService = new ProductCategoryService();
    productCategoryService.loadProductCategorys((data: any) => {
      this.productCategoryList = data;
    });

    const tagService = new TagService();
    tagService.loadTagsByType("product", (data: any) => {
      const tags: Tag[] = data;
      this.tagOptions = [];
      tags.forEach((item) => {
        this.tagOptions.push({
          value: item.id,
          label: item.name,
        });
      });
    });

    tagService.loadTagsByType("productCategory", (data: any) => {
      this.productCategorys = data;
    });
  }

  public afterLoad() {
    const product = this.entity as Product;
    product.deleteProductQuantitys = [];
    this.injectDetailData(
      product.productQuantitys!,
      product.deleteProductQuantitys!
    );
    this.generateRowNo();

    if (product.tagIds) {
      const tempTagValues: number[] = [];
      const stagIds = product.tagIds?.split(",");
      stagIds.forEach((item) => {
        tempTagValues.push(Number(item));
      });
      this.tagValues = tempTagValues;
    } else {
      this.tagValues = [];
    }
  }

  public beforeSave() {
    this.entity.tagIds = this.tagValues?.join(",");
    return true;
  }

  uploadFile(param: any) {
    const path = "shop";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.productService.uploadFile(formData).then(
      (result) => {
        const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${param.file.name}`;
        this.entity.img = uploadUrl;
      },
      (error: Error) => {
        ElMessage.error("上传图片失败！原因：" + error);
      }
    );
  }

  private getProperty(name: string): ProductProperty | null {
    let result: ProductProperty | null = null;
    const product = this.entity as Product;
    product.productPropertys!.forEach((item) => {
      if (item.name === name) {
        result = item;
      }
    });
    return result;
  }

  setEditorContent(name: string) {
    if (this.$refs.editor) {
      const property = this.getProperty(name);
      if (property) {
        if (this.preProperty !== "") {
          const prePropertyContent = this.getProperty(this.preProperty);
          prePropertyContent!.content = (
            this.$refs.editor as TinymceEditor
          ).getContent();
        }
        (this.$refs.editor as TinymceEditor).setContent(property.content);        
        this.preProperty = name;
      }
    }
  }
}
